<template>
    <ModalComponent
        :name="'borrar-' + recordatorio.id"
        title="¿Seguro que quieres borrar el recordatorio para este evento?"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <p><b>Nombre</b> {{ recordatorio.nombre }}</p>
                        <p><b>Email:</b> {{ recordatorio.email }}</p>
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR RECORDATORIO?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarRecordatorio">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['recordatorio'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.recordatorio.id, borrado);
            },
            borrarRecordatorio() {
                this.loading = true;

                const params = {
                    filters : {},
                    recordatorio_id: this.recordatorio.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.recordatorios.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
